<template>
	<fieldset v-if="visible" :class="clazz" :style="style">
		<legend v-if="!!fs.legend">
			<component :is="componentOfPart(legendPart)" :part="partRef(legendPart)" :data="localData" :readonly="ro" :viewmode="vm"></component>
		</legend>
		<component :is="componentOfPart(bodyPart)" :part="partRef(bodyPart)" :data="localData" :readonly="ro" :viewmode="vm"></component>
	</fieldset>
</template>

<script setup lang="ts">
import useContainer, {type ContainerProps, containerProps} from "./Container";
import type {Fieldset} from "@t/fd/layout/Fieldset";
import {EMPTY_PART} from "../ComponentResolver";
import {computed} from "vue";

const uprops = defineProps({ ...containerProps });
const props = uprops as ContainerProps;

const fs = computed<Fieldset>(() => props.part as Fieldset);
const { visible, componentOfPart, partRef, localData, ro, vm, clazz, style } = useContainer(props);

const legendPart = computed(() => {
	return fs.value.legend || EMPTY_PART;
});
const bodyPart = computed(() => {
	return fs.value.body || EMPTY_PART;
});
</script>

<style>

</style>